function map(tween, fn) {
  return {
    prev: fn(tween.prev, "prev"),
    next: fn(tween.next, "next")
  };
}

function withDefault(t, deft) {
  return {
    prev: (t === null || t === void 0 ? void 0 : t.prev) === undefined ? deft : t.prev,
    next: (t === null || t === void 0 ? void 0 : t.next) === undefined ? deft : t.next
  };
}

function mapWithDefault(tween, deft, fn) {
  return map(withDefault(tween, deft), fn);
}

export { map, mapWithDefault, withDefault };